export class UsersActions {
  static readonly SET_USERS = '[USERS] SET';
}
